var map = {
	"./role-1/r-1-1.png": "tE3x",
	"./role-1/r-1-2.png": "qdEL",
	"./role-1/r-1-3.png": "hddW",
	"./role-1/r-1-4.png": "QxKF",
	"./role-1/r-1-5.png": "qjog",
	"./role-2/r-2-1.png": "8NMT",
	"./role-2/r-2-2.png": "qPdf",
	"./role-2/r-2-3.png": "i7Ua",
	"./role-2/r-2-4.png": "unB+",
	"./role-3/r-3-1.png": "MInN",
	"./role-3/r-3-2.png": "Xk3S",
	"./role-3/r-3-3.png": "iRKS",
	"./role-3/r-3-4.png": "xPf6",
	"./role-4/r-4-1.png": "W4tY",
	"./role-4/r-4-2.png": "RLog",
	"./role-4/r-4-3.png": "uj9l",
	"./role-4/r-4-4.png": "zAEu",
	"./role-4/r-4-5.png": "NIf1",
	"./role-5/r-5-1.png": "dfW9",
	"./role-5/r-5-2.png": "PFGo",
	"./role-5/r-5-3.png": "E3va",
	"./role-5/r-5-4.png": "zjwc"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "cpK8";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3 ^\.\/role\-.*\.png$
// module id = cpK8
// module chunks = 0